import {
  createContext, useContext, useMemo, useState,
} from 'react';
import type React from 'react';
import type { PropsWithChildren } from 'react';

type DepartmentListListMode = 'ownership' | 'view';

interface DepartmentListListContextValue {
  mode: DepartmentListListMode;
  setMode: (mode: DepartmentListListMode) => void;
}

const DepartmentListListContext = createContext<DepartmentListListContextValue | null>(null);

function DepartmentListListProvider({
  children,
}: PropsWithChildren): React.JSX.Element {
  const [mode, setMode] = useState<DepartmentListListMode>('ownership');

  const value = useMemo(
    () => ({ mode, setMode }),
    [mode],
  );

  return (
    <DepartmentListListContext.Provider value={value}>
      {children}
    </DepartmentListListContext.Provider>
  );
}

function useDepartmentListListContext(): DepartmentListListContextValue {
  const context = useContext(DepartmentListListContext);

  if (context === null) {
    throw new Error('useDepartmentListListContext must be used within DepartmentListListProvider');
  }

  return context;
}

export { DepartmentListListProvider, useDepartmentListListContext };
export type { DepartmentListListMode };
